export default __webpack_public_path__ + "static/media/case_top_bg.ba084186.png";